import type {
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AssetTag } from '@Types/assets';
export type { AssetTag };
import service from '../service';
import { stableStringify } from '../utils/searchParams';

type AssetTagsResponse = {
  data: AssetTag[];
  meta?: {
    total?: number;
    pageSize?: number;
    pageNumber?: number;
    totalPages?: number;
  };
};
type DefaultError = unknown;

type UseAssetTagsParams<S extends Record<string, any> = Record<string, any>> = {
  searchParams?: S;
  enabled?: boolean;
};

export const assetTagKeys = {
  all: ['asset-tags'] as const,
  list: (searchParams?: Record<string, any>) =>
    ['asset-tags', stableStringify(searchParams)] as const,
};

export function useAssetTags<TData = AssetTagsResponse, TError = DefaultError>(
  { searchParams, enabled = true }: UseAssetTagsParams = {},
  options?: Omit<
    UseQueryOptions<AssetTagsResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  return useQuery<AssetTagsResponse, TError, TData>({
    queryKey: assetTagKeys.list(searchParams),
    enabled,
    queryFn: async () => {
      return service.getAssetTags({
        sort: 'name',
        ...(searchParams ?? {}),
      });
    },
    ...(options as any),
  });
}
